export const contentTableConfig = {
  title: '客户列表',
  propList: [
    {prop: 'uname', label: '客户昵称', minWidth: '120', slotName: 'consumer', align: 'left'},
    {prop: 'unionid', label: 'UnionID', minWidth: '80', align: 'left'},
    {prop: 'corpName', label: '主体名称', minWidth: '80', align: 'left'},
    {prop: 'sid', label: '账号ID', minWidth: '80', align: 'left'},
    {prop: 'sname', label: '账号名称', minWidth: '80', align: 'left'},
    {prop: 'usedBy', label: '使用人', minWidth: '80', align: 'left'},
    {prop: 'deptName', label: '所属部门', minWidth: '80', align: 'left'},
    {prop: 'groupName', label: '所属组', minWidth: '80', align: 'left'}
  ],
  showIndexColumn: false,
  showSelectColumn: true
}
